<template>
  <div v-if="isLoad" class="container-wrapper">
    <a
      href="#"
      class="close-btn"
      role="button"
      @click.prevent="goTo"
    >
      {{ _.get(getStockPolicy, 'closeButtonText', '') || getMain.closeButtonText }}
    </a>

    <section class="container policy-page">
      <p class="policy-page__content" v-html="_.get(getStockPolicy, 'policyText', '') || getMain.policyText" />
    </section>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'PolicyPage',
    data () {
      return {
        title: '',
        backLinkText: '',
        content: '',
        componentReady: false
      }
    },
    computed: {
      ...mapGetters(['getMain', 'isLoad', 'getStockPolicy'])
    },

    beforeMount () {
      localStorage.removeItem('stockPolicy')
    },

    beforeDestroy () {
      this.$store.commit('clearStockPolicy')
    },

    methods: {
      goTo () {
        if (this._.get(this.getStockPolicy, 'formSubmitUrl', '')) {
          localStorage.removeItem('stockPolicy')
        }

        this.$router.go(-1)
      }
    }
  }
</script>

<style lang="scss">
  .close-btn {
    display: block;
    width: 200px;
    width: max-content;
    padding: 0 48px;
    margin-bottom: 40px;
    margin-left: auto;
    font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
    font-size: 15px;
    line-height: 48px;
    color: #fff;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    background: $c-gray-dark;
    border-radius: 24px;
    transition: background-color 0.4s, color 0.4s;

    @include hover {
      background-color: $c-gray;
    }
  }

  .policy-page {
    * {
      // font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      color: $c-gray-dark;
    }

    // h1,
    // h2,
    // h3,
    // h4,
    // h5,
    // h6 {
    //   color: $c-black;
    // }

    // h1 {
    //   font-family: "ToyotaDisplay", Arial, Helvetica, sans-serif;
    //   font-size: 44px;
    //   font-weight: 700;
    //   line-height: 1.36;

    //   @include mobile {
    //     font-size: 24px;
    //     line-height: 1.42;
    //   }
    // }

    // h2 {
    //   font-family: "ToyotaDisplay", Arial, Helvetica, sans-serif;
    //   font-size: 34px;
    //   font-weight: 400;
    //   line-height: 45px;
    // }

    // h3 {
    //   font-family: "NotoSans", Arial, Helvetica, sans-serif;
    //   font-size: 21px;
    //   font-weight: 400;
    //   line-height: 28px;
    // }

    // h4 {
    //   font-family: "NotoSans", Arial, Helvetica, sans-serif;
    //   font-size: 19px;
    //   font-weight: 400;
    //   line-height: 26px;
    // }

    // h5,
    // h6 {
    //   font-family: "NotoSans", Arial, Helvetica, sans-serif;
    //   font-size: 17px;
    //   font-weight: 900;
    //   line-height: 23px;
    // }

    // a {
    //   font-size: 16px;

    //   &:hover {
    //     color: $c-active;
    //     text-decoration: none;
    //     border-bottom: 0;
    //     transition: 0.5s;
    //   }

    //   @include mobile {
    //     font-size: 13px;
    //   }
    // }

    strong {
      font-weight: 900;
    }

    ol,
    ul {
      margin-left: 20px;

      li {
        padding-left: 10px;
      }
    }
  }
</style>
